module.exports = __webpack_public_path__ + "media/games-14.5a898864.mp4";